export const parseFileInfo = (item, path) => {
  const name = item.name;
  const extension = getFileExtension(name).toLowerCase();

  // Skip certain file types
  if (shouldSkipFile(name, extension)) {
    return null;
  }

  const filePath = path ? `${path}/` : '';
  const type = extractProblemType(name);
  const lang = extension;
  const date = item.last_modified || new Date().toISOString();

  return {
    name,
    path: filePath,
    type,
    lang,
    date,
    size: item.size,
    sha: item.sha,
    download_url: item.download_url
  };
};

export const shouldSkipFile = (name, extension) => {
  const skipExtensions = ['md', 'txt', 'gitignore', 'json', 'yml', 'yaml'];
  const skipFiles = ['README.md', '.gitignore', 'package.json', 'LICENSE'];

  return skipFiles.includes(name) || skipExtensions.includes(extension);
};

export const shouldSkipDirectory = (dirName) => {
  const skipDirs = ['.git', '.github', 'node_modules', '.vscode', '.idea', 'src', 'public'];
  return skipDirs.includes(dirName);
};

export const extractProblemType = (filename) => {
  const match = filename.match(/(\d{2}-\d{2}-)?(DT|DC)-/);
  if (match) {
    return match[2]; // Returns 'DT' or 'DC'
  }

  // Check for special categories
  if (filename.includes('PRIME') || filename.includes('Prime')) return 'PRIME';
  if (filename.includes('HOPE') || filename.includes('Elevate') || filename.includes('Training')) return 'TRAINING';
  if (filename.includes('MNC') || filename.includes('Question')) return 'MNC';
  if (filename.includes('Special') || filename.includes('Concept')) return 'CONCEPT';

  return 'OTHER';
};

export const getFileExtension = (filename) => {
  const lastDot = filename.lastIndexOf('.');
  return lastDot !== -1 ? filename.substring(lastDot + 1) : '';
};

export const getFileIcon = (lang) => {
  const icons = {
    'java': { icon: 'fab fa-java', class: 'lang-java' },
    'c': { icon: 'fas fa-code', class: 'lang-c' },
    'cpp': { icon: 'fas fa-code', class: 'lang-c' },
    'py': { icon: 'fab fa-python', class: 'lang-py' },
    'js': { icon: 'fab fa-js-square', class: 'lang-js' },
    'html': { icon: 'fab fa-html5', class: 'lang-html' },
    'css': { icon: 'fab fa-css3-alt', class: 'lang-css' },
    'png': { icon: 'fas fa-image', class: 'lang-image' },
    'jpg': { icon: 'fas fa-image', class: 'lang-image' },
    'jpeg': { icon: 'fas fa-image', class: 'lang-image' },
    'gif': { icon: 'fas fa-image', class: 'lang-image' },
    'pdf': { icon: 'fas fa-file-pdf', class: 'lang-pdf' },
    'txt': { icon: 'fas fa-file-alt', class: 'lang-text' },
    'md': { icon: 'fab fa-markdown', class: 'lang-markdown' }
  };

  return icons[lang.toLowerCase()] || { icon: 'fas fa-file', class: 'lang-default' };
};

export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
};

export const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};

export const highlightText = (text, query) => {
  if (!query) return text;
  const regex = new RegExp(`(${escapeRegExp(query)})`, 'gi');
  return text.replace(regex, '<span class="search-highlight">$1</span>');
};

const escapeRegExp = (string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};